import React, { useCallback } from 'react';
import { isNumber, isString } from 'lodash'
import { Input } from '@treelab/panda';

import { IFilterValue } from '../../../../../../types/form-type'

interface IProps {
  name: string;
  value: IFilterValue;
  onChange: (value: { [key: string]: any }) => void;
}

const DefaultInput: React.FC<IProps> = ({ name, value, onChange }) => {
  const { filterString } = value
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const data = e.target.value
    onChange({ filterString: data })
  }, [onChange])
  return (
    <Input.Text
      input={{
        name: `${name}.filterString`,
        value: isString(filterString) || isNumber(filterString) ? filterString : '',
        onChange: handleChange,
      }}
      meta={{}}
    />
  )
}

export default DefaultInput
